export default __webpack_public_path__ + "static/banner-ES-mov-fb75f692a5c1331fb6ab6331830e629f.png";